import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ backgroundColor: "#F9F9F9" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              AI-Powered Solutions for <span>Diverse Businesses</span>
            </h2>
            <p>
              We have worked with clients in the diverse business ecosystems and
              helped them build their best for business. Here are our favorite
              sectors we have almost revolutionized with our AI software
              development services.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Discuss Now
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Healthcare</h4>
                  <p>
                    AI-powered solutions from TekRevol have enhanced diagnostics
                    and patient management, personalized medical consultancy and
                    improved patient outcomes for healthcare organizations.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Real Estate</h4>
                  <p>
                    In the proptech sector, our AI software provide property
                    recommendations, market analysis, and predictive maintenance
                    to help make mortgage and investment-related decisions.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Ecommerce</h4>
                  <p>
                    For the ecommerce and retail businesses, AI apps help with
                    personalized product recommendations, on-point marketing,
                    and inventory management.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Logistics and Supply Chain</h4>
                  <p>
                    We build AI solutions like driver and fuel monitoring
                    systems that optimize logistics and supply chain management
                    through predictive analytics, demand forecasting, and route
                    optimization. Our clients in this sector have reduced costs
                    and improved service levels up to 40% within 3 months of
                    deployment.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Sports</h4>
                  <p>
                    TekRevol’s clients in the sports industry have leveraged AI
                    for performance analysis, injury prediction, and fan
                    engagement.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Fintech</h4>
                  <p>
                    AI has its finest and most advanced applications in the
                    fintech sector – AI-powered solutions are helping with fraud
                    detection, risk management, and automated trading with
                    better investment decision-making.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Gaming</h4>
                  <p>
                    In the gaming sector, we have utilized AI to improve the
                    player by twofold. We have built AI-based models that
                    understand users’ habit loops and then recommend in-app
                    purchases accordingly.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Manufacturing</h4>
                  <p>
                    We utilize a mix of AI models and applications to automate
                    the manufacturing process and underlying steps like material
                    sorting. Our solutions can improve quality control, and
                    predictive maintenance, and optimize the supply chain to
                    drive efficiency and innovation in factory settings.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
